import { render, staticRenderFns } from "./CMultiselect.vue?vue&type=template&id=3b838207"
import script from "./CMultiselect.vue?vue&type=script&lang=js"
export * from "./CMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CMultiselect.vue?vue&type=style&index=0&id=3b838207&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports